import { DATA_SET_PAGINATION_COUNT } from 'constants/dataSets';
import { API_METHODS } from 'constants/general';
import {
  NOTIFICATIONS_LIST, NOTIFICATIONS_READ_ALL, NOTIFICATIONS_READ_ONE,
  NOTIFICATIONS_UNREAD_COUNT,
} from 'constants/requestUrls';
import mainApi from 'store/apis/mainApi';
import NOTIFICATIONS_LIST_TAG from 'store/tags/notifications';

import type { IBaseQueryPaginationResponse } from 'store/types/IBaseQueryPaginationResponse';
import type ICountResponse from '../interfaces/ICountResponse';
import type INotification from '../interfaces/INotification';
import type INotificationsListRequest from '../interfaces/INotificationsListRequest';
import type IReadOneRequest from '../interfaces/IReadOneRequest';

export const notificationsApi = mainApi.injectEndpoints({
  endpoints: (build) => ({
    getNotifications: build.query<IBaseQueryPaginationResponse<INotification[]>, INotificationsListRequest>({
      query: ({
        offset, status,
      }) => ({
        url: NOTIFICATIONS_LIST,
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          ...(status && { status }),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: NOTIFICATIONS_LIST_TAG, id }))]
          : [NOTIFICATIONS_LIST_TAG]
      ),
    }),
    readOneNotification: build.mutation<void, IReadOneRequest>({
      query: ({ notificationId }) => ({
        url: NOTIFICATIONS_READ_ONE.replace('{notificationId}', `${notificationId}`),
        method: API_METHODS.post,
      }),
      invalidatesTags: [NOTIFICATIONS_LIST_TAG],
    }),
    readAllNotifications: build.mutation<void, void>({
      query: () => ({
        url: NOTIFICATIONS_READ_ALL,
        method: API_METHODS.post,
      }),
      invalidatesTags: [NOTIFICATIONS_LIST_TAG],
    }),
    getCountUnreadNotifications: build.query< ICountResponse, void>({
      query: () => ({
        url: NOTIFICATIONS_UNREAD_COUNT,
      }),
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useReadOneNotificationMutation,
  useReadAllNotificationsMutation,
  useGetCountUnreadNotificationsQuery,
  useLazyGetCountUnreadNotificationsQuery,
} = notificationsApi;
